import { QRCode } from "antd";
import React from "react";

interface CommandCenterQRCodeCardProps {
    url: string;
}

const CommandCenterQRCodeCard: React.FC<CommandCenterQRCodeCardProps> = ({ url }) => {
    return (
        <div className="flex flex-row items-center justify-center gap-2 p-4 rounded-lg shadow-sm border bg-neutral-800 border-neutral-700">
            <div className="flex flex-row items-center">
                <QRCode
                    value={url}
                    icon="/img/png/logo/PLOT-P.png"
                    bgColor="transparent"
                    color="#FFFFFF"
                    className="h-full w-full max-w-full"
                />
            </div>

            <div className="text-xl text-neutral-100 font-semibold leading-tight text-center break-words">
                SCAN TO BOOK A DELIVERY AS GUEST
            </div>
        </div>
    );
};

export default CommandCenterQRCodeCard;
